/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable consistent-return */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-child-element-spacing */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { useTimer } from 'react-timer-hook';
import { Col, Row, message as toaster } from 'antd';
import { Form, Input } from 'formik-antd';
import { Formik } from 'formik';
// import { useTimer } from 'react-timer-hook';
import { Box, Button, Text } from 'atoms';
import * as SVGICONS from 'utils/svg';
import { FormActionButtons } from 'forms/FormActionButtons';
import {
	additionalResourcesLogin,
	LoginSales,
	resendOtp,
	resetSalesManPin,
	setLoginPin,
	validateMobile,
	validateOTP,
} from 'store/userSlice';
import { setinvoiceDate } from 'store/appSlice';
import { FormPassWord } from 'forms/Login.form';

export default function SalesLoginForm() {
	const dispatch = useDispatch();
	const history = useHistory();
	const [isMobile, setIsMobile] = useState(false);
	const [isSalesActive, SetIsSalesActive] = useState(true);
	const [isAdminActive, SetisAdminActive] = useState(false);
	// const time = new Date();
	const countDownDate = new Date().getTime();

	console.log(countDownDate);

	const [verifyOtpandPin, checkverifyOtpandPin] = useState({
		pin: false,
		otp: false,
	});

	const TIMER = 120;
	const time = new Date();

	time.setSeconds(time.getSeconds() + TIMER);

	time.setSeconds(time.getSeconds() + TIMER);
	const { seconds, minutes, isRunning, restart } = useTimer({
		time,
		onExpire: () => console.warn('onExpire called'),
	});

	function triggerTimer() {
		const triggerTime = new Date();

		triggerTime.setSeconds(triggerTime.getSeconds() + TIMER);
		restart(triggerTime);
	}

	console.log(seconds, minutes, isRunning);

	const [pincodeBLock, SetPinCodeBlock] = useState(false);

	const [misMAtchPin, SetMisMAtchPin] = useState(false);
	const [wrongPin, setWrongPin] = useState(false);
	const [enableWrongPin, setenableWrongPin] = useState(false);

	console.log(isMobile);
	const image_container = {
		margin: '10px 20px',
		padding: '20px 10px',
		textAlign: 'center',
	};

	const styleBg = {
		backgroundColor: 'white',
		height: '100vh',
		margin: '3px',
		marginLeft: '20px 40px',
	};

	const WelcomeContainer = {
		width: '216px',
		height: '83px',
	};
	const welcomeTo = {
		fontFamily: 'Open Sans',
		fontSize: '16px',
		fontWeight: '400',
		lineHeight: '22px',
	};

	const salesCollection = {
		fontFamily: 'Open Sans',
		fontSize: '20px',
		fontWeight: '700',
		lineHeight: '28px',
		letterSpacing: '0em',
		textAlign: 'left',
	};

	const initialValues = {
		phone: undefined,
		email: undefined,
		password: undefined,
		otp: undefined,
		pin: undefined,
	};

	function validateRipplrEmail(email) {
		/* eslint-disable no-useless-escape */
		const RIPPLR_MAIL = '@ripplr.in';
		const emailRegExp =
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (
			emailRegExp.test(email) &&
			email.indexOf(RIPPLR_MAIL, email.length - RIPPLR_MAIL.length) !== -1
		) {
			// Email valid. Procees to test if it's from the right domain (Second argument is to check that the string ENDS with this domain, and that it doesn't just contain it)
			return true;
		}

		return false;
	}

	function validateMobileNumber(email) {
		const phoneRegExp = /^[6-9]\d{9}$/gi;

		if (phoneRegExp.test(email)) {
			return true;
		}

		return false;
	}

	function validateEmailMobile(data) {
		if (validateRipplrEmail(data)) {
			return true;
		}
		if (validateMobileNumber(data)) {
			return true;
		}

		return false;
	}

	console.log(validateEmailMobile);

	const getYupObj = () => {
		if (isSalesActive) {
			return Yup.object({
				phone: Yup.number()
					.required()
					.label('Mobile')
					.test('Enter Correct Mobile number', (value) => validateMobileNumber(value)),
				otp: Yup.string()
					.when('isSalesActive', {
						is: true,
						then: Yup.string().required('Required'),
					})
					.matches(/^[0-9]+$/, 'Must be only digits')
					.min(4, 'Must be exactly 4 digits')
					.max(4, 'Must be exactly 4 digits'),
			});
		}
		if (isAdminActive) {
			return Yup.object({
				email: Yup.string()
					.required()
					.label('Email')
					.test('Enter Correct Email', (value) => validateRipplrEmail(value)),
				password: Yup.string().label('Password').min(5).required(),
			});
		}
	};

	const FormSchema = getYupObj();

	const getPin = (values) => {
		if (values?.pin && values?.confirmotp) {
			return true;
		}
		if (
			values?.pin === '' ||
			values?.confirmotp === '' ||
			values?.pin === undefined ||
			values?.confirmotp === ''
		) {
			toaster.error('please enter PIN and Confim PIN ');

			return false;
		}
	};

	const [otpBlockActive, setOtpBlockActive] = useState(false);
	const [mobileValidateBlockActive, setOtpmobileValidateBlockActive] = useState(false);
	const [pinlock, setPinLock] = useState(false);

	function optActiveFunction() {
		setOtpBlockActive(true);
	}
	function mobileValidateFunction() {
		setOtpmobileValidateBlockActive(true);
	}

	function setActivePinBlock() {
		setPinLock(true);
	}

	console.log(pinlock);
	const [hideAdmin, setHidetheAdmin] = useState(false);

	function handleSubmit(values, { setErrors, resetForm, setSubmitting, setFieldValue }) {
		if (validateMobileNumber(values.phone)) {
			setHidetheAdmin(true);
			if (
				mobileValidateBlockActive &&
				values.phone &&
				values.otp === undefined &&
				values?.pin === undefined &&
				verifyOtpandPin?.otp === false &&
				verifyOtpandPin?.pin === false
			) {
				dispatch(validateMobile({ mobile: values.phone }, setErrors))
					.then((res) => {
						console.log(res);
						triggerTimer();
						setSubmitting(false);
						checkverifyOtpandPin(res);
						if (res?.otp) {
							toaster.success('OTP sent to you');
						}
					})
					.catch((e) => {
						setSubmitting(false);
						console.log('OTP catch', e);
					})
					.finally(() => {
						// setSubmitting(false);
					});
			}
			if (verifyOtpandPin?.otp) {
				if (
					!otpBlockActive &&
					verifyOtpandPin?.otp &&
					values.phone &&
					values?.otp === undefined &&
					verifyOtpandPin?.pin === false
				) {
					setSubmitting(false);
					toaster.error('please enter OTP');
				} else if (
					otpBlockActive &&
					verifyOtpandPin?.otp &&
					values.phone &&
					values?.otp === undefined &&
					verifyOtpandPin?.pin === false
				) {
					setSubmitting(false);
					toaster.error('please enter OTP');
				} else if (
					otpBlockActive &&
					values.phone &&
					values?.otp === '' &&
					verifyOtpandPin?.pin === false
				) {
					setSubmitting(false);
					toaster.error('please enter OTP');
				} else if (otpBlockActive && values.phone && values?.otp !== undefined) {
					dispatch(validateOTP({ mobile: values.phone, otp: values.otp }, setErrors))
						.then((res) => {
							console.log(res);
							SetPinCodeBlock(true);
							setOtpBlockActive(false);
							setFieldValue('otp', '');
							setOtpmobileValidateBlockActive(false);

							setSubmitting(false);
						})
						.catch((e) => {
							console.log(e);
							setSubmitting(false);

							console.log('OTP catch', e);
						})
						.finally(() => {
							// setSubmitting(false);
						});
				}
			}
			if (verifyOtpandPin?.pin && enableWrongPin === false && pincodeBLock === false) {
				if (values?.phone === undefined || values?.phone === '') {
					setSubmitting(false);
					toaster.error('please enter mobile');
				} else if (values?.pin === undefined || values?.pin === '') {
					setSubmitting(false);
					toaster.error('please enter pin');
				}
				if (values?.phone && values?.pin) {
					dispatch(LoginSales({ mobile: values.phone, ...values }, setErrors))
						.then((res) => {
							dispatch(setinvoiceDate());
							// setSubmitting(false);
							// resetForm();
							console.log(res, 'maain result');
							if (res?.data?.login_version === 'v2') {
								history.push('/invoices-collection');
							} else {
								history.push('/collection');
							}
						})
						.catch((e) => {
							setSubmitting(false);
							setWrongPin(true);
							console.log('Sales Man catch', e);
						})
						.finally(() => {
							// setSubmitting(false);
						});
				}
			}
			if (enableWrongPin) {
				if (values?.phone === undefined || values?.phone === '') {
					setSubmitting(false);
					toaster.error('please enter mobile');
				}

				if (values?.otp === undefined || values?.otp === '') {
					setSubmitting(false);
					toaster.error('please enter OTP');
				}

				if (values?.phone && values?.otp) {
					dispatch(validateOTP({ mobile: values.phone, otp: values.otp }, setErrors))
						.then((res) => {
							console.log(res);
							SetPinCodeBlock(true);
							setenableWrongPin(false);
							setOtpBlockActive(false);
							setFieldValue('otp', '');
							setOtpmobileValidateBlockActive(false);

							setSubmitting(false);
						})
						.catch((e) => {
							console.log(e);
							setSubmitting(false);

							console.log('OTP catch', e);
						})
						.finally(() => {
							// setSubmitting(false);
						});
				}
				setSubmitting(false);
			}
			if (pincodeBLock) {
				if (
					values?.phone &&
					values?.pin === undefined &&
					values?.confirmotp === undefined
				) {
					setSubmitting(false);
					toaster.error('please enter pin and confirm pin');
				} else if (
					values?.phone &&
					values?.pin === '' &&
					values?.confirmotp === undefined
				) {
					setSubmitting(false);
					toaster.error('please enter pin and confirm pin');
				} else if (values?.phone && values?.pin === '' && values?.confirmotp === '') {
					setSubmitting(false);
					toaster.error('please enter pin and confirm pin');
				} else if (
					values?.phone &&
					values?.pin !== undefined &&
					values?.confirmotp === undefined
				) {
					setSubmitting(false);
					toaster.error('please enter confirm pin');
				} else if (
					pincodeBLock &&
					values?.phone &&
					values?.pin === undefined &&
					values?.confirmotp !== undefined
				) {
					setSubmitting(false);
					toaster.error('please enter pin');
				} else if (
					pincodeBLock &&
					values?.phone &&
					values?.pin === '' &&
					values?.confirmotp !== undefined
				) {
					setSubmitting(false);
					toaster.error('please enter pin');
				} else if (
					pincodeBLock &&
					values?.phone &&
					values?.pin !== undefined &&
					values?.confirmotp === ''
				) {
					setSubmitting(false);
					toaster.error('please enter confirm pin');
				}
				// eslint-disable-next-line sonarjs/no-collapsible-if
				if (pincodeBLock && values?.phone && values?.pin && values?.confirmotp) {
					if (getPin(values)) {
						if (values.pin === values?.confirmotp) {
							dispatch(setLoginPin({ mobile: values.phone, ...values }, setErrors))
								.then((res) => {
									// SetrejectModal(true);
									console.log(res);
									window.location.reload();
								})
								.catch((e) => {
									setSubmitting(false);
									console.log('Sales Man catch', e);
								})
								.finally(() => {
									// setSubmitting(false);
								});
						} else {
							setSubmitting(false);
							toaster.error('Confirm pin doesnt match with New Pin ');
							SetMisMAtchPin(true);
						}
					}
				}
				setSubmitting(false);
			}
		} else if (validateRipplrEmail(values.email)) {
			if (validateRipplrEmail(values.email) && values.password === undefined) {
				console.log('sjdn');
			}
			if (validateRipplrEmail(values.email) && values.password !== '') {
				setIsMobile(false);
				dispatch(additionalResourcesLogin(values, setErrors))
					.then((res) => {
						dispatch(setinvoiceDate());
						console.log(res, 'maain result');
						// history.push('/sales-men');
						if (res?.data?.login_version === 'v1') {
							history.push('/sales-men');
						} else {
							history.push('/salesmenlist');
						}
						setSubmitting(false);
						resetForm();
					})
					.catch((e) => {
						setSubmitting(false);
						console.log('Login form catch', e);
					})
					.finally(() => {
						// setSubmitting(false);
					});
			}
		}
	}

	function resendOTP(values) {
		// triggerTimer();
		console.log(values);
		triggerTimer();
		dispatch(resendOtp(values))
			.then(() => {
				console.log('');
				toaster.success('OTP sent to you');
			})
			.catch((e) => {
				console.log('Login form catch', e);
			})
			.finally(() => {
				// setSubmitting(false);
			});
	}

	function forgMyPin(values, setFieldValue) {
		// triggerTimer();
		triggerTimer();
		setenableWrongPin(true);
		const defaultPinAndOTP = {
			pin: false,
			otp: false,
		};

		checkverifyOtpandPin(defaultPinAndOTP);

		dispatch(resetSalesManPin(values))
			.then(() => {
				setFieldValue('pin', undefined);
			})
			.catch((e) => {
				console.log('Login form catch', e);
			})
			.finally(() => {
				// setSubmitting(false);
			});
	}

	const wrongPincontainer = {
		textAlign: 'center',
		padding: '10px',
		margin: '2px 2px',
		background: '#FFF2F2',
	};

	const wrongpinStyle = {
		color: '#FD6770',
		width: '100%',
	};

	const forgetPinStyle = {
		width: '100%',
		color: '#113F5F',
		marginTop: '10px',
	};

	// const checkValuesPin = (values, setErrors) => {
	// 	console.log(values, setErrors);
	// 	if (values?.pin !== values?.confirmotp) {
	// 		setErrors({ confirmotp: 'Kindly check pin and confim pin' });
	// 		SetMisMAtchPin(true);
	// 	}
	// 	if (values?.pin === values?.confirmotp) {
	// 		SetMisMAtchPin(false);
	// 	}
	// };

	// const salesmanStyle = {
	// 	padding: '5px 5px',
	// 	textAlign: 'center',
	// 	borderRadius: '17px',
	// 	width: '105px',
	// 	height: '34px',
	// 	fontWeight: '600',
	// };

	const handleSalesClick = () => {
		SetisAdminActive(false);
		SetIsSalesActive(true);
	};

	const handleAdminClick = () => {
		console.log('jhbsd');
		SetIsSalesActive(false);
		SetisAdminActive(true);
	};

	const Adminactive = {
		padding: '5px 5px',
		textAlign: 'center',
		borderRadius: '17px',
		width: '120px',
		height: '34px',
		fontWeight: '600',
		backgroundColor: '#007FFF',
		color: '#fff',
		marginLeft: '-20px',
		cursor: 'pointer',
	};
	const AdminNOtactive = {
		padding: '5px 5px',
		textAlign: 'center',
		borderRadius: '17px',
		width: '120px',
		height: '34px',
		fontWeight: '600',
		backgroundColor: '#F1F1F1',
		color: '#000',
		marginLeft: '-20px',
		cursor: 'pointer',
	};

	const Salesactive = {
		padding: '5px 5px',
		textAlign: 'center',
		borderRadius: '17px',
		width: '105px',
		height: '34px',
		fontWeight: '600',
		zIndex: '2',
		backgroundColor: '#007FFF',
		color: '#fff',
		cursor: 'pointer',
	};

	const SalesNOtactive = {
		padding: '5px 5px',
		textAlign: 'center',
		borderRadius: '17px',
		width: '105px',
		height: '34px',
		fontWeight: '600',
		zIndex: '2',
		backgroundColor: '#F1F1F1',
		color: '#000',
		cursor: 'pointer',
	};

	const hideSection = {
		display: 'none',
	};

	const newBadge = {
		color: 'red',
		fontWeight: '700',
		fontSize: '16px',
	};

	console.log(hideSection);

	const validDisbale = () => {
		if (seconds === 0 && minutes === 0) {
			return false;
		}

		return true;
	};

	console.log(seconds, minutes, validDisbale());

	// const getPadString = (val) => {
	// 	const num_str = val.toString();

	// 	return num_str.padStart(2, '0');
	// };

	console.log(isSalesActive, isAdminActive);

	return (
		<Formik
			enableReinitialize
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
		>
			{({ values, errors, isSubmitting, resetForm, setFieldValue }) => (
				<Form layout="vertical" style={{ marginTop: '-20px' }}>
					{console.log(errors)}
					<Box style={styleBg}>
						{console.log(values, isSubmitting, resetForm)}
						<Box style={{ margin: '20px 40px' }}>
							{/* <Box>
								<Col span={8} className="center">
									<Text fontWeight="600" fontSize="16px">
										<span>{mins}</span>:<span>{seconds}</span>
									</Text>
								</Col>
							</Box> */}
							<Box style={{ height: '60vh' }}>
								<Box style={image_container}>
									<SVGICONS.RipplrSVG />
								</Box>
								<Box style={WelcomeContainer}>
									<Box>
										<Text style={welcomeTo}>
											Welcome to <span style={newBadge}> NEW </span>
										</Text>
										<Text style={salesCollection}>Sales Collection Module</Text>
									</Box>{' '}
								</Box>
								<Box>
									<Box style={{ marginTop: '20px' }}>
										<Row gutter={8} justify="space-between">
											<Col span={6}>
												{' '}
												<Box
													style={
														isSalesActive ? Salesactive : SalesNOtactive
													}
													onClick={handleSalesClick}
												>
													{' '}
													Salesman{' '}
												</Box>{' '}
											</Col>
											<Col span={16} style={hideAdmin ? hideSection : ''}>
												{' '}
												<Box
													style={
														isAdminActive ? Adminactive : AdminNOtactive
													}
													onClick={handleAdminClick}
												>
													Admin{' '}
												</Box>
											</Col>
										</Row>
									</Box>
								</Box>
								<Box>
									{' '}
									{isSalesActive && (
										<Box>
											{!pincodeBLock && (
												<Box>
													<Box style={{ marginTop: '20px' }}>
														<Row gutter={8} justify="space-between">
															<Col span={24}>
																<Form.Item
																	name="phone"
																	hasFeedback={false}
																	showValidateSuccess={false}
																	label="Salesman Phone Number"
																	className="custom-label"
																	labelCol={{ span: 24 }}
																	wrapperCol={{ span: 24 }}
																>
																	<Input
																		disabled={
																			verifyOtpandPin?.otp ||
																			verifyOtpandPin?.pin ||
																			enableWrongPin
																		}
																		type="number"
																		name="phone"
																		pattern="[0-9]{10}"
																		maxLength={10}
																		inputmode="decimal"
																		onChange={() => {
																			mobileValidateFunction();
																		}}
																	/>
																</Form.Item>
															</Col>
														</Row>
													</Box>

													{verifyOtpandPin?.otp && (
														<>
															<Row gutter={8} justify="space-between">
																<Col span={24}>
																	<Form.Item
																		name="otp"
																		hasFeedback={false}
																		showValidateSuccess={false}
																		label="Enter OTP to Create PIN"
																		className="custom-label"
																		labelCol={{ span: 24 }}
																		wrapperCol={{ span: 24 }}
																	>
																		<Input.Password
																			pattern="[0-9]{4}"
																			type="number"
																			name="otp"
																			maxLength={4}
																			onChange={() => {
																				optActiveFunction();
																			}}
																			inputmode="decimal"
																		/>
																	</Form.Item>
																</Col>
															</Row>
															<Row
																gutter={8}
																justify="space-between"
																align="middle"
																className="mb-20"
															>
																<Col span={8}></Col>
																<Col span={8} className="center">
																	{isRunning && (
																		<Text
																			fontWeight="600"
																			fontSize="16px"
																		>
																			<span>{minutes}</span>:
																			<span>
																				{seconds < 10
																					? '0'
																					: ''}
																			</span>
																			<span>{seconds}</span>
																		</Text>
																	)}
																</Col>
																<Col span={8} className="right">
																	<Button
																		type="button"
																		disabled={
																			seconds > 0 ||
																			minutes > 0
																		}
																		style={{
																			cursor: 'pointer',
																			color: '#113F5F',
																			border: '0',
																			background: '#ffff',
																			fontWeight: '600',
																			fontSize: '10px',
																		}}
																		onClick={() =>
																			resendOTP(values)
																		}
																	>
																		Resend OTP
																	</Button>
																</Col>
															</Row>
														</>
													)}
													{verifyOtpandPin?.pin && (
														// eslint-disable-next-line react/jsx-no-useless-fragment
														<>
															{!enableWrongPin && (
																<Box
																	hidden={validateRipplrEmail(
																		values.email
																	)}
																>
																	<Row
																		gutter={8}
																		justify="space-between"
																	>
																		<Col span={24}>
																			<Form.Item
																				name="pin"
																				hasFeedback={false}
																				showValidateSuccess={
																					false
																				}
																				label="PIN Number"
																				className="custom-label"
																				labelCol={{
																					span: 24,
																				}}
																				wrapperCol={{
																					span: 24,
																				}}
																			>
																				<Input.Password
																					pattern="[0-9]{4}"
																					type="number"
																					name="pin"
																					maxLength={4}
																					inputmode="decimal"
																					onChange={() => {
																						setActivePinBlock();
																					}}
																				/>
																			</Form.Item>
																		</Col>
																	</Row>
																	<Row></Row>
																	{wrongPin && (
																		<Row
																			style={
																				wrongPincontainer
																			}
																		>
																			<Box
																				style={
																					wrongpinStyle
																				}
																			>
																				You Have Entered
																				Wrong PIN
																			</Box>
																		</Row>
																	)}
																	<Row
																		style={{
																			textAlign: 'center',
																		}}
																	>
																		<Box style={forgetPinStyle}>
																			{' '}
																			<span
																				style={{
																					cursor: 'pointer',
																					fontWeight:
																						'600',
																				}}
																				onClick={() =>
																					forgMyPin(
																						values,
																						setFieldValue
																					)
																				}
																			>
																				{' '}
																				Forgot PIN?
																			</span>{' '}
																		</Box>
																	</Row>
																</Box>
															)}
														</>
													)}
													{enableWrongPin && (
														<>
															<Row gutter={8} justify="space-between">
																<Col span={24}>
																	<Form.Item
																		name="otp"
																		hasFeedback={false}
																		showValidateSuccess={false}
																		label="Enter OTP to Create PIN"
																		className="custom-label"
																		labelCol={{ span: 24 }}
																		wrapperCol={{ span: 24 }}
																	>
																		<Input.Password
																			type="number"
																			name="otp"
																			pattern="[0-9]{4}"
																			maxLength={4}
																			inputmode="decimal"
																			onChange={() => {
																				optActiveFunction();
																			}}
																		/>
																	</Form.Item>
																</Col>
															</Row>
															<Row
																gutter={8}
																justify="space-between"
																align="middle"
																className="mb-20"
															>
																<Col span={8}></Col>
																<Col span={8} className="center">
																	{' '}
																	{isRunning && (
																		<Text
																			fontWeight="600"
																			fontSize="16px"
																		>
																			<span>{minutes}</span>:
																			<span>
																				{seconds < 10
																					? '0'
																					: ''}
																			</span>
																			<span>{seconds}</span>
																		</Text>
																	)}
																</Col>
																<Col span={8} className="right">
																	<Button
																		type="button"
																		disabled={
																			seconds > 0 ||
																			minutes > 0
																		}
																		style={{
																			cursor: 'pointer',
																			color: '#113F5F',
																			border: '0',
																			background: '#ffff',
																			fontWeight: '600',
																			fontSize: '10px',
																		}}
																		onClick={() =>
																			resendOTP(values)
																		}
																	>
																		Resend OTP
																	</Button>

																	{/* <Button
																		hidden={validDisbale}
																		type="button"
																		disabled={validDisbale}
																		style={{
																			cursor: 'pointer',
																			color: '#113F5F',
																			border: '0',
																			background: '#ffff',
																			fontWeight: '600',
																			fontSize: '10px',
																		}}
																		onClick={() =>
																			resendOTP(values)
																		}
																	>
																		Resend OTP
																	</Button> */}
																</Col>
															</Row>
														</>
													)}
												</Box>
											)}

											{pincodeBLock && (
												<Box style={{ marginTop: '35px' }}>
													<Row gutter={8} justify="space-between">
														<Col span={24}>
															<Form.Item
																name="pin"
																hasFeedback={false}
																showValidateSuccess={false}
																label="Create Pin"
																className="custom-label"
																labelCol={{ span: 24 }}
																wrapperCol={{ span: 24 }}
															>
																<Input.Password
																	type="number"
																	name="pin"
																	pattern="[0-9]{4}"
																	inputmode="decimal"
																	maxLength={4}
																/>
															</Form.Item>
														</Col>
													</Row>
													<Row gutter={8} justify="space-between">
														<Col span={24}>
															<Form.Item
																name="comfirmpin"
																hasFeedback={false}
																showValidateSuccess={false}
																label="Confirm PIN"
																className="custom-label"
																labelCol={{ span: 24 }}
																wrapperCol={{ span: 24 }}
															>
																<Input.Password
																	type="number"
																	name="confirmotp"
																	maxLength={4}
																	pattern="[0-9]{4}"
																	inputmode="decimal"
																/>
															</Form.Item>
														</Col>
													</Row>
													<Row>
														<Box
															style={{
																color: '#8A8787',
																display: 'flex',
															}}
														>
															<SVGICONS.RightPinLableSVG
																style={{
																	marginTop: '5px',
																	marginRight: '5px',
																}}
															/>{' '}
															PIN Should be 4 digit numbers
														</Box>
													</Row>
													{misMAtchPin && (
														<Row style={wrongPincontainer}>
															<Box style={wrongpinStyle}>
																PIN and Confirm PIN Should match
															</Box>
														</Row>
													)}
												</Box>
											)}
										</Box>
									)}
								</Box>
								<Box>
									{isAdminActive && (
										<Box>
											<Box style={{ marginTop: '60px' }}>
												<Row gutter={8} justify="space-between">
													<Col span={24}>
														<Form.Item
															name="email"
															hasFeedback={false}
															showValidateSuccess={false}
															label="Admin"
															className="custom-label"
															labelCol={{ span: 24 }}
															wrapperCol={{ span: 24 }}
														>
															<Input name="email" type="email" />
														</Form.Item>
													</Col>
												</Row>
												<Row gutter={8} justify="space-between">
													<Col span={24}>
														<FormPassWord
															name="password"
															hasFeedback={false}
															showValidateSuccess={false}
															label="Password"
															className="custom-label"
															labelCol={{ span: 24 }}
															wrapperCol={{ span: 24 }}
														>
															<Input.Password name="password" />
														</FormPassWord>
													</Col>
												</Row>
											</Box>
										</Box>
									)}
								</Box>
								<Box style={{ marginTop: '20px' }}>
									<FormActionButtons
										resetForm={resetForm}
										isSubmitting={isSubmitting}
										showDebug={false}
										saveText={
											isMobile || validateRipplrEmail(values.email)
												? 'Login'
												: 'Submit'
										}
										cancelText="Reset"
										showCancel={false}
										isValid={
											!(
												isMobile &&
												!validateRipplrEmail(values.email) &&
												values.otp === ''
											)
										}
									/>
								</Box>
							</Box>
						</Box>
					</Box>
				</Form>
			)}
		</Formik>
	);
}
